import { NgModule } from '@angular/core';
import { ChatbotEntryModule } from '../../../shared/customer-service/chatbot/chatbot-entry/chatbot-entry.module';
import { InsuranceImagesModule } from '../../../shared/insurance/insurance-images/insurance-images.module';
import { InsuranceModule } from '../../../shared/insurance/insurance.module';
import { ListModule } from '../../../shared/ux/lists/list.module';
import { CardModule } from '../../shared/card/card.module';
import { ProductCardModule } from '../../shared/product-card/product-card.module';
import { VerzekeringenPageHemaRoutingModule } from './verzekeringen-page-hema-routing.module';
import { VerzekeringenPageHemaComponent } from './verzekeringen-page-hema.component';
import { WucCardModule, WucLinkModule, WucPictureModule } from '@inshared/website-ui-components';

@NgModule({
    declarations: [
        VerzekeringenPageHemaComponent,
    ],
    imports: [
        VerzekeringenPageHemaRoutingModule,
        ChatbotEntryModule,
        InsuranceModule,
        InsuranceImagesModule,
        ProductCardModule,
        CardModule,
        ListModule,
        WucLinkModule,
        WucCardModule,
        WucPictureModule
    ],
    exports: [
        VerzekeringenPageHemaComponent,
    ],
})
export class VerzekeringenPageHemaModule {
}
